import styled from 'styled-components';
import { H3, SmallP } from '../../style/typography';
import { min } from '../../lib/responsive';

const BasicSectionContainer = styled.section`
  text-align: left;
  padding: 5rem 0;
  @media ${min.tabletLg} {
    width: 50%;
  }
`;

const HeaderText = styled(H3)`
  text-transform: uppercase;
  margin: 0;
`;

const Content = styled(SmallP)`
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
`;

const MarginContainer = styled.div`
  margin: 0 1rem;
  @media ${min.mobile} {
    margin: 0 2rem;
  }
  @media ${min.tabletSm} {
    margin: 0 3rem;
  }
  @media ${min.tablet} {
    margin: 0 5rem;
  }
`;

export { BasicSectionContainer, HeaderText, Content, MarginContainer };
